import DeleteTypeDialog from './DeleteTypeDialog';

export default DeleteTypeDialog;
